
import 'reflect-metadata';
import { getPropNames } from '../reflection';

import { TimeSlotType } from '../bookings';
import { IStripeSubscriptionData, LeadStatus } from './BaseUserProfile';
import { ISignupSource } from './ISignupSource';

import { StripeSubscriptionStatus } from '../wrapper';
import { Level } from './level';
import { ProgramType } from './ProgramType';

import { Gender } from '../general';
import { IUserLeaderboardPreferences } from '../leaderboard';

export enum MemberReportErrors {
  nameExist = 'nameExist',
}

export interface IMemberColumnData {
    accessor?: string;
    used: boolean;
    sortable?: boolean;
    width?: number;
  }

export enum ReportType {
  members = 'members',
  workouts = 'workouts',
}

export interface IUserWorkoutAggregate {
  totalCompletedStudio: number;
  totalMissedStudio: number;
  totalCancelledStudio: number;
  totalCompleted: number;
  totalMissedHome: number;
  totalCompletedHome: number;
  totalHRCompleted: number;
  totalBurnCompleted: number;
  totalBuildCompleted: number;
  totalBalanceCompleted: number;
  totalCustomisedCompleted: number;
  firstWorkout: number | string;
  lastWorkout: number | string;
  totalDurationInMinutes: number;
  totalCalories: number;
  totalEffortPoints: number;
  totalStudio28mins: number;
  totalStudio48mins: number;
  totalHome17mins: number;
  totalHome29mins: number;
  totalHome42mins: number;
  userProfileId?: string;
}

export function propNamesIUserDataForMemberManagement() { return getPropNames<IUserDataForMemberManagement>();}
export interface IUserDataForMemberManagement {
  uid: string;
  gymName?: string;
  stripeUserId: string;
  email: string;
  fullname: string;
  dateOfBirth: string;
  gender: Gender;
  continueSignupToken: string | undefined;
  mobileNumber: string;
  longTermGoal: ProgramType;
  skillLevel: Level;
  isStreamingUser?: boolean;
  leadStatus?: LeadStatus;
  signupSource?: ISignupSource;
  followUpDate?: Date;
  userSignupDate: string;
  ptApprovedAt: number;
  currentPlanExpiresAt: number | undefined;
  currentPlanId: string | undefined;
  currentPlanCancelAtEndOfTerm: boolean;
  currentPlanStatus: StripeSubscriptionStatus;
  stripeSubscriptionData: IStripeSubscriptionData;
  timeSlotType: TimeSlotType;
  planHistory: string[];
  teams?: string[];
  leaderboardPreferences?: IUserLeaderboardPreferences;
  employeeId?: string;
  companyId?: string;
}

export class MembersReportData {
    public reportId: string;
    public reportName: string;
    public dateCreated: Date;
    public memberColumnData: IMemberColumnData[];
    public sortOrder?: Array<{ id: string; desc: any; }>;
    public filters?: Array<{ id: string; value: any; pivotId?: string }>;
    public selected: boolean;
    public reportType?: ReportType;
  }
